import { z } from 'zod'
import { nonEmpty, optionalText, uuid } from './common.ts'

// Rupees as typed, to two decimal places. Kept as a string all the way to
// the database so it is never turned into a float on the way.
const rupees = z.union([z.string(), z.number()])
  .transform(v => String(v).trim())
  .refine(v => /^\d{1,9}(\.\d{1,2})?$/.test(v), {
    message: 'Enter an amount like 13.33',
  })

const rate = z.coerce.number().min(0).max(100)

export const createProduct = z.object({
  id: uuid,
  name: nonEmpty(160),
  description: optionalText(1000),
  /** Taxable value, excluding CGST and SGST. */
  price: rupees,
  cgstRate: rate.default(2.5),
  sgstRate: rate.default(2.5),
  imagePath: z.string().trim().max(400).optional().nullable(),
})
export type CreateProduct = z.infer<typeof createProduct>

export const updateProduct = z.object({
  name: nonEmpty(160).optional(),
  description: optionalText(1000),
  price: rupees.optional(),
  cgstRate: rate.optional(),
  sgstRate: rate.optional(),
  imagePath: z.string().trim().max(400).optional().nullable(),
  isActive: z.boolean().optional(),
  version: z.number().int().positive(),
})
export type UpdateProduct = z.infer<typeof updateProduct>
